/*
 * Seed IM - Service to manage configuration for the app stored in the repo.
 */
import { Injectable } from '@angular/core';
//import { LogService, ViewUtilService } from '@alfresco/adf-core';
import { Router } from '@angular/router';
//import { PasswordDialog } from 'projects/aca-testing-shared/src';

@Injectable()
export class ViewDocumentService {
  // logService: any;
  // contentApi: any;
  // http: any;

  constructor(
    //private viewUtil: ViewUtilService,
    //private logService: LogService,
    private router: Router
    //viewDocumentService: ViewDocumentService
    ) {
  }

  /**
     * Launch the File view in a new tab from anywhere other than the preview service, which resolves the
     * rendition of the object that can be printed from a web browser.
     * These are: images, PDF files, or PDF rendition of files.
     * We also force PDF rendition for TEXT type objects, otherwise the default URL is to download.
     * TODO there are different TEXT type objects, (HTML, plaintext, xml, etc. we should determine how these are handled)
     *
  viewFileGeneric(objectId: string, mimeType: string): void {
      const nodeId = objectId;
      const type: string = this.viewUtil.getViewerTypeByMimeType(mimeType);

      this.viewUtil.getRendition(nodeId, ViewUtilService.ContentGroup.PDF)
      .then(value => {
          const url: string = this.viewUtil.getRenditionUrl(nodeId, type, (value ? true : false));
          const printType = (type === ViewUtilService.ContentGroup.PDF
              || type === ViewUtilService.ContentGroup.TEXT)
              ? ViewUtilService.ContentGroup.PDF : type;
          this.viewFile(url, printType);
      })
      .catch(err => {
          this.logService.error('Error with Viewing');
          this.logService.error(err);
      });
  }
*/

openInNewTab(nodeId: string) {

  var url = this.router.serializeUrl(
    this.router.createUrlTree(['/aev/preview', nodeId])
  );
  url = url.replace("/aev", "/#/aev");
  console.log("The", url);
  //let newWindow =
  window.open(url, '_blank'); // Open the URL in a new tab
  // newWindow.onload = function() {
  //   newWindow.document.title = "Custom Title for New Tab";
  // };
}


// viewFileGeneric(objectId: string, mimeType: string): void {
//   const nodeId = objectId;
//   const type: string = this.viewUtil.getViewerTypeByMimeType(mimeType);

//   this.viewUtil.getRendition(nodeId, ViewUtilService.ContentGroup.PDF)
//   .then(value => {
//       const url: string = this.viewUtil.getRenditionUrl(nodeId, type, (value ? true : false));
//  //     const printType = (type === ViewUtilService.ContentGroup.PDF
//  //         || type === ViewUtilService.ContentGroup.TEXT)
//  //         ? ViewUtilService.ContentGroup.PDF : type;
//       this.viewFile(url);
//   })
//   .catch(err => {
//       this.logService.error('Error with Viewing');
//       this.logService.error(err);
//   });
// }


  /**
       * This method takes a url to trigger the tab against the type of artifact that it
       * is.
       * This URL should be one that can be rendered in the browser, for example PDF, Image, or Text
  */
  viewFile(url: string): void {
    //const pwa = window.open(url, ViewUtilService.TARGET);

    //const pwa = window.open(url, "_blank");

    //var url = "http://localhost:4200/#/libraries/24b012cf-dccb-4b6e-b248-aa25b87c0884/(viewer:view/8849e2d7-489f-4838-a13d-a342c85b2048)?location=%2Flibraries%2F24b012cf-dccb-4b6e-b248-aa25b87c0884";
    //const pwa = window.open(url, "_blank");
    window.open(url, "_blank");


    // if (pwa) {
    //   // set the titlee
    //   pwa.onload = function() { pwa.document.title = "Title change"; }

    //   // Because of the way chrome focus and close image window vs. pdf preview window
    //     if (type === ViewUtilService.ContentGroup.IMAGE) {
    //         pwa.onfocus = () => {
    //             setTimeout( () => {
    //                 pwa.close();
    //             }, 500);
    //         };
    //     }
    // }
  }

}
